module.exports = __webpack_public_path__ + "static/media/1 44 kanskje.e94f770d.mp3";